import { call, put, takeLatest } from 'redux-saga/effects';
import { GET_CONTACT_US, GET_CONTACT_US_ERROR, GET_CONTACT_US_SUCCESS } from '../constants';
import { appendLocaleInCMSRequest } from '../network';
export function* getContactUs(data) {
    try {
        let result = {};
        const { payload } = data;
        const response = yield call(payload.object.getEntries, appendLocaleInCMSRequest(payload.contentFull));
        if (response && response !== undefined && response !== null) {
            result = {
                ...result,
                contactUsResp: response,
            };
            yield put({
                type: GET_CONTACT_US_SUCCESS,
                response: result,
            });
        }
        else {
            yield put({
                type: GET_CONTACT_US_ERROR,
            });
        }
    }
    catch (error) {
        yield put({
            type: GET_CONTACT_US_ERROR,
        });
    }
}
export default function* contactUsSaga() {
    yield takeLatest(GET_CONTACT_US, getContactUs);
}
